import * as angular from "angular";
import { 
	ActionAdapter, 
	ActionsAdapter 
} from "./adapters";
import { 
	Action, 
	ActionOrPattern, 
	ActionScope, 
	Pattern 
} from "./actionScopes";

class SecurityService {
	private $logger;
	private $appState;
	private securityActions: ActionsAdapter;

	constructor($logger) {
		this.$logger = $logger;
	}

	public init = (securityBlob: any) => {
		const formSecurity = securityBlob;
		
		const selectedRoleCode = formSecurity.Assigned?.[0]?.Code;
		const selectedRole = selectedRoleCode && formSecurity.Roles.find(r => r.Code == selectedRoleCode);

		if(!selectedRole) {
			this.securityActions = new ActionsAdapter([]);

			return;
		}

		const formActionAdapters = selectedRole.Actions.map(a => new ActionAdapter(a));

		this.securityActions = new ActionsAdapter(formActionAdapters).reduce();
	}

	public isActionAllowed = (action: string) => {
		return this.securityActions.isAllowed(new Action(action));
	};

	public isPatternAllowed = (pattern: string) => {
		return this.securityActions.isAllowed(new Pattern(pattern));
	};

	public isActionOrPatternAllowed = (actionOrPattern: string) => {
		return this.securityActions.isAllowed(new ActionOrPattern(actionOrPattern));
	};

	public isActionScopeAllowed = (actionScope: ActionScope) => {
		return this.securityActions.isAllowed(actionScope);
	};

	public hasApplicablePermission = (action: string) => {
		return this.securityActions.hasSubpath(action);
	}
}

export default angular
	.module("vesl.services.security-service", [])
	.service("securityService", SecurityService).name;